<nav
  class="bg-primary mobile-nav-menu d-flex flex-column d-lg-none"
  role="navigation"
  aria-label="Mobile navigation"
>
  <!-- NAV BAR -->
  <div class="mobile-nav-bar d-flex justify-content-between align-items-center">
    <a class="nav-brand" [routerLink]="['/']" aria-label="Go to homepage">
      <img
        class="home-logo"
        [src]="'logos/logowhite.png' | contentAssetImage"
        draggable="false"
        alt="Club logo"
      />
    </a>

    <div class="right-mobile-nav-container">
      <fgb-notification-button></fgb-notification-button>

      <button
        class="nav-toggler"
        (click)="isCollapsed = !isCollapsed"
        [attr.aria-expanded]="!isCollapsed"
        aria-controls="mobile-nav-dropdown"
        aria-label="Open navigation menu"
      >
        <span class="material-icons" aria-hidden="true">menu</span>
      </button>
    </div>
  </div>

  <!-- NAV SCREEN -->
  <div
    id="mobile-nav-dropdown"
    [ngbCollapse]="isCollapsed"
    class="mobile-nav-dropdown"
    role="dialog"
    aria-modal="true"
    aria-label="Navigation menu"
  >
    <div class="mobile-nav-content">
      <!-- Header -->
      <div class="nav-header">
        <a [routerLink]="['/']" aria-label="Go to homepage">
          <img
            class="home-logo"
            [src]="'logos/logoblack.png' | contentAssetImage"
            draggable="false"
            alt="Club logo"
          />
        </a>
        <button class="close-btn" (click)="isCollapsed = !isCollapsed" aria-label="Close navigation menu">
          <span class="material-icons text-info" aria-hidden="true">close</span>
        </button>
      </div>

      <!-- Country / Language -->
      <div class="mobile-country-row" #countryRow (click)="openLanguageSelector($event, countryRow)">
        <span class="mobile-country-label">{{ 'nav.country' | translate: { fgbdefault: 'Country:' } }}</span>
        <fgbcl-language-button-select
          class="mobile-country-select"
          [hiddenLanguagesByLcid]="['4105', '1033', '1032', '1037', '3084', '1036']"
          [version]="2"
        ></fgbcl-language-button-select>
        <span class="mobile-country-change">{{ 'nav.country.change' | translate: { fgbdefault: 'Change' } }}</span>
      </div>

      <!-- Nav Links -->
      <ul class="nav-list" role="list">
        <li>
          <a
            class="nav-link"
            [routerLink]="['/account']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-symbols-outlined nav-icon filled" aria-hidden="true">account_circle</span>
            <span class="nav-label">{{ 'nav.account' | translate }}</span>
          </a>
        </li>
        <li>
          <a
            class="nav-link"
            [routerLink]="['/rewards/wallet']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-icons nav-icon" aria-hidden="true">account_balance_wallet</span>
            <span class="nav-label">{{ 'nav.redemption.history' | translate: { fgbdefault: 'Redemption History' } }}</span>
          </a>
        </li>
        <li>
          <a
            class="nav-link"
            [routerLink]="['/rewards']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-icons nav-icon" aria-hidden="true">redeem</span>
            <span class="nav-label">{{ 'nav.rewards' | translate }}</span>
          </a>
        </li>
        <li>
          <a
            class="nav-link"
            [routerLink]="['/challenges']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-icons nav-icon" aria-hidden="true">emoji_events</span>
            <span class="nav-label">{{ 'nav.challenges' | translate }}</span>
          </a>
        </li>
        <li>
          <a
            class="nav-link"
            [routerLink]="['/games']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-icons nav-icon" aria-hidden="true">sports_esports</span>
            <span class="nav-label">{{ 'nav.games' | translate }}</span>
          </a>
        </li>
        <li>
          <a
            class="nav-link"
            [routerLink]="['/benefits']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-symbols-outlined nav-icon filled" aria-hidden="true">rewarded_ads</span>
            <span class="nav-label">{{ 'nav.benefits' | translate: { fgbdefault: 'Benefits' } }}</span>
          </a>
        </li>
        <li>
          <a
            class="nav-link"
            [routerLink]="['/offers']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-symbols-outlined nav-icon filled" aria-hidden="true">percent_discount</span>
            <span class="nav-label">{{ 'nav.exclusive.offers' | translate: { fgbdefault: 'Exclusive Offers' } }}</span>
          </a>
        </li>
        <li>
          <a
            class="nav-link"
            [routerLink]="['/newsletters']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-symbols-outlined nav-icon filled" aria-hidden="true">newsmode</span>
            <span class="nav-label">{{ 'nav.newsletter' | translate: { fgbdefault: 'Newsletter' } }}</span>
          </a>
        </li>
        <li>
          <a
            class="nav-link"
            [routerLink]="['/gallery']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-icons nav-icon" aria-hidden="true">video_library</span>
            <span class="nav-label">{{ 'nav.gallery' | translate }}</span>
          </a>
        </li>
        <li class="nav-accordion">
          <button
            class="nav-link nav-accordion-toggle"
            (click)="isHelpOpen = !isHelpOpen"
            [attr.aria-expanded]="isHelpOpen"
            aria-controls="help-submenu"
          >
            <span class="material-icons nav-icon" aria-hidden="true">info</span>
            <span class="nav-label">{{ 'nav.help' | translate: { fgbdefault: 'Help' } }}</span>
            <span class="material-icons accordion-chevron" [class.open]="isHelpOpen" aria-hidden="true">expand_more</span>
          </button>
          <ul id="help-submenu" class="nav-submenu" [ngbCollapse]="!isHelpOpen" role="list">
            <li>
              <a class="nav-sublink" [routerLink]="['/terms']">{{ 'nav.terms' | translate }}</a>
            </li>
            <li>
              <a class="nav-sublink" [routerLink]="['/faq']">{{ 'nav.faq' | translate }}</a>
            </li>
            <li>
              <a class="nav-sublink" [routerLink]="['/contact']">{{ 'nav.contact.us' | translate }}</a>
            </li>
          </ul>
        </li>
      </ul>

      <!-- Log Out -->
      <div class="nav-footer">
        <button class="logout-btn" (click)="logout()" aria-label="Log out of your account">
          <span class="material-icons" aria-hidden="true">logout</span>
          <span class="font-size-14 font-heading">{{ 'nav.log.out' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</nav>
